<template>
<section class="profile-grid">
    <article class="brand-panel profile-card">
        <div class="card-label">Gameplay statistics</div>
        <div class="metric-row">
            <span>Sessions played</span>
            <strong>{{ gameplay.sessions }}</strong>
        </div>
        <div class="metric-row">
            <span>Gameplay events</span>
            <strong>{{ gameplay.events }}</strong>
        </div>
    </article>

    <article class="brand-panel profile-card">
        <div class="card-label">Account details</div>
        <div class="metric-row">
            <span>Email</span>
            <strong>{{ profile.email }}</strong>
        </div>
        <div class="metric-row">
            <span>Name</span>
            <strong>{{ profile.name }}</strong>
        </div>
    </article>
</section>
</template>

<script>
import ProfileService from '@/services/profile.service.js';

    export default {
        name: 'Profile',

        data () {
            return {
                gameplay: {
                    sessions: null,
                    events: null,
                },
                profile : {
                    email: null,
                    name: null,
                },
            }
        },

        mounted: function() {
            ProfileService.getSessionData()
            .then(response => {
                this.gameplay.sessions = response.data['session_count'];
                this.gameplay.events = response.data['events_count'];
            })

            ProfileService.getAccountData()
            .then(response => {
                this.profile.email = response.data['data']['user']['email'];
                this.profile.name = response.data['data']['name'];
            })
        }
    }
</script>

<style scoped>
.profile-grid {
    display: grid;
    gap: 1rem;
}

.profile-card {
    padding: 1.25rem;
}

.card-label {
    display: inline-flex;
    margin-bottom: 1rem;
    padding: 0.35rem 0.65rem;
    border: 2px solid var(--ss-line);
    border-radius: 999px;
    background: var(--ss-yellow);
    font-size: 0.78rem;
    font-weight: 950;
    text-transform: uppercase;
}

.metric-row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.8rem 0;
    border-top: 2px solid rgba(22, 20, 15, 0.12);
}

.metric-row span {
    color: var(--ss-muted);
    font-weight: 800;
}

.metric-row strong {
    text-align: right;
    overflow-wrap: anywhere;
}
</style>
